/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespSkinnyBannerModule_componentModule = {
    readonly messages: {
        readonly imageUrl?: string | null;
        readonly imageHeight?: string | null;
        readonly imageWidth?: string | null;
        readonly mobileImageUrl?: string | null;
        readonly mobileImageHeight?: string | null;
        readonly mobileImageWidth?: string | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
        readonly cta: string | null;
        readonly imageCopy: string | null;
        readonly isFullBleedImage: boolean | null;
    } | null;
    readonly " $refType": "HpRespSkinnyBannerModule_componentModule";
};
export type HpRespSkinnyBannerModule_componentModule$data = HpRespSkinnyBannerModule_componentModule;
export type HpRespSkinnyBannerModule_componentModule$key = {
    readonly " $data"?: HpRespSkinnyBannerModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespSkinnyBannerModule_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespSkinnyBannerModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "SkinnyBannerModuleItemMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cta",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageCopy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFullBleedImage",
          "storageKey": null
        },
        {
          "condition": "isMobile",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageWidth",
              "storageKey": null
            }
          ]
        },
        {
          "condition": "isMobile",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileImageHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileImageWidth",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SkinnyBannerModule",
  "abstractKey": null
};
(node as any).hash = 'edb3ce23679a5e7635bc21c1b2f82463';
export default node;
